<ng-container *ngIf="userInfo$ | async"></ng-container>
<div class="dialog-half mfa-modal">
  <ng-container [ngSwitch]="view">
    <ng-container *ngSwitchCase="'initial'">
      <h6>{{ "mfa_has_not_yet_been_enabled_lingo" | translation }}</h6>
      <h6>{{ "setup_additional_security_at_this_time" | translation }}</h6>
      <div class="mfa-modal-button-container">
        <button (click)="showMfaSetup()" nbButton status="primary">
          {{ "yes" | translation }}
        </button>
        <button (click)="close()" status="primary" nbButton>
          {{ "later" | translation }}
        </button>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'options'">
      <h6>
        MFA can be setup on your phone via text messages or through an
        authenticator app or both
      </h6>
      <div class="mfa-modal-button-container">
        <button
          [disabled]="smsVerified || isLoading"
          (click)="initSmsMfaSetup()"
          class="mfa-modal-option-button"
          nbButton
        >
          Text Message
        </button>
        <button
          [disabled]="totbVerified || isLoading"
          class="mfa-modal-option-button"
          (click)="initTotbMfaSetup()"
          nbButton
        >
          Authenticator App
        </button>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'mfa'">
      <ng-container *ngIf="secretCode">
        <h6>
          {{ "please_download_an_authenticator_app_lingo" | translation }}
        </h6>
        <app-qr-code [secretCode]="secretCode"></app-qr-code>
        <h6>
          {{
            "please_enter_the_code_that_is_displayed_within_your_authenticator_app"
              | translation
          }}
        </h6>
        <form (keydown.enter)="submitTotbUsercode($event)">
          <div class="mfa-modal-user-input-container">
            <input
              placeholder="Code"
              nbInput
              [(ngModel)]="totbCode"
              [ngModelOptions]="{ standalone: true }"
            />
            <div class="mfa-modal-user-button-container">
              <button
                [disabled]="isSubmitting"
                (click)="showMfaSetup()"
                nbButton
                status="primary"
              >
                {{ "back" | translation }}
              </button>
              <button
                type="submit"
                [disabled]="isSubmitting || !totbCode"
                (click)="submitTotbUsercode($event)"
                nbButton
                status="primary"
              >
                {{ "submit" | translation }}
              </button>
            </div>
          </div>
        </form>
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'sms'">
      <h6>Please provide the code sent to your phone number</h6>
      <div style="text-align: center" *ngIf="phoneNumberUsed">
        {{ phoneNumberUsed }}
      </div>
      <form (keydown.enter)="submitTotbUsercode($event)">
        <div class="mfa-modal-user-input-container">
          <input
            placeholder="Code"
            nbInput
            [(ngModel)]="smsCode"
            [ngModelOptions]="{ standalone: true }"
          />
          <div class="mfa-modal-user-button-container">
            <button
              [disabled]="isSubmitting"
              (click)="showMfaSetup()"
              nbButton
              status="primary"
            >
              {{ "back" | translation }}
            </button>

            <button
              type="submit"
              [disabled]="isSubmitting || !smsCode"
              (click)="submitSmsCode($event)"
              nbButton
              status="primary"
            >
              {{ "submit" | translation }}
            </button>
          </div>
        </div>
      </form>
    </ng-container>
  </ng-container>
</div>
